export interface NewsItem {
  id: string;
  title: string;
  category: '最新动态' | '活动报道' | '媒体采访' | '作品发布';
  date: string;
  thumb: string;
  summary: string;
  content: string[];
  relatedWorkId?: string;
}

export const news: NewsItem[] = [
  {
    id: 'n001',
    title: '深田咏美主演新片《夜色微光》正式定档 11 月',
    category: '作品发布',
    date: '2026-09-28',
    thumb:
      'https://readdy.ai/api/search-image?query=cinematic%20press%20photo%20of%20an%20elegant%20woman%20at%20a%20dimly%20lit%20city%20premiere%2C%20muted%20grey%20tones%20with%20deep%20red%20accents%2C%20editorial%20photography%2C%20soft%20film%20grain%2C%20high%20detail&width=800&height=600&seq=enews-01&orientation=landscape',
    summary:
      '由深田咏美领衔主演的都市悬疑电影《夜色微光》宣布定档 11 月 8 日，首支预告同步释出，影片聚焦都市孤独者的情感困境。',
    content: [
      '电影《夜色微光》正式宣布定档 11 月 8 日全国公映，并同步释出首支正式预告。深田咏美在片中饰演一位在城市夜班中独自生活的女性，因一封未寄出的信件而卷入一段被时间掩埋的往事。',
      '导演佐藤健吾在发布会上表示，影片希望用克制的镜头语言去还原都市人的真实情绪，而不是依靠强情节推动。深田咏美为了贴近角色，提前两个月体验了夜班生活，并在拍摄期间坚持使用现场收音。',
      '首支预告片时长 1 分 42 秒，以霓虹与雨夜构成视觉主线，结尾一句「有些灯，只为一个人亮着」成为网友热议的台词。影片同时确认将参加多个国际影展的展映单元。',
    ],
    relatedWorkId: 'w001',
  },
  {
    id: 'n002',
    title: '《东京流年》口碑持续走高，收官集收视创同时段新高',
    category: '最新动态',
    date: '2026-09-21',
    thumb:
      'https://readdy.ai/api/search-image?query=cinematic%20editorial%20photo%20of%20a%20rainy%20Tokyo%20street%20with%20warm%20shop%20lights%2C%20muted%20grey%20and%20deep%20burgundy%20tones%2C%20moody%20film%20still%2C%20high%20detail&width=800&height=600&seq=enews-02&orientation=landscape',
    summary:
      '都市情感剧《东京流年》迎来收官，凭借细腻的生活化叙事获得观众一致好评，深田咏美饰演的插画师成为讨论焦点。',
    content: [
      '由深田咏美主演的都市情感剧《东京流年》于上周迎来收官，收官集在同时段收视中创下新高，网络平台讨论热度持续攀升。',
      '剧集以四季为章节，讲述四位年轻人在东京重逢与告别的一年。深田咏美饰演的女主角是一位从地方来到大都市追梦的插画师，在理想与现实的夹缝中重新认识自己。',
      '不少观众表示，剧中最打动人的是那些「什么都没发生」的日常片段。编剧高桥美咲在采访中透露，很多对白都来自真实的采风记录，因此格外有生活质感。',
    ],
    relatedWorkId: 'w002',
  },
  {
    id: 'n003',
    title: '深田咏美受邀出席东京国际电影节开幕红毯',
    category: '活动报道',
    date: '2026-09-15',
    thumb:
      'https://readdy.ai/api/search-image?query=elegant%20film%20festival%20red%20carpet%20scene%20with%20warm%20spotlights%20and%20a%20muted%20grey%20backdrop%2C%20deep%20red%20accent%20carpet%2C%20editorial%20photography%2C%20cinematic%20mood%2C%20high%20detail&width=800&height=600&seq=enews-03&orientation=landscape',
    summary:
      '深田咏美以嘉宾身份出席东京国际电影节开幕式，一袭深红色礼服造型成为红毯焦点，并参与了主竞赛单元的映后交流。',
    content: [
      '第某届东京国际电影节正式开幕，深田咏美以特邀嘉宾身份出席开幕式红毯。当晚她以一袭深红色礼服亮相，简约利落的造型被多家时尚媒体选为「当晚最佳着装」。',
      '在红毯采访中，深田咏美表示自己最近更关注角色背后的普通人故事，希望未来能尝试更多类型的作品。她还在现场用中文向中国观众问好，引发在场媒体欢呼。',
      '电影节期间，深田咏美参与了主竞赛单元的映后交流活动，与导演及主创团队一同分享创作幕后。主办方表示，本次活动吸引了来自多个国家和地区的影人参与。',
    ],
  },
  {
    id: 'n004',
    title: '对话深田咏美：我更在意角色有没有「活过」',
    category: '媒体采访',
    date: '2026-09-06',
    thumb:
      'https://readdy.ai/api/search-image?query=editorial%20magazine%20interview%20scene%20with%20elegant%20minimal%20grey%20set%20and%20warm%20lighting%2C%20muted%20tones%20with%20deep%20red%20accent%20chair%2C%20cinematic%20photography%2C%20high%20detail&width=800&height=600&seq=enews-04&orientation=landscape',
    summary:
      '在一场深度专访中，深田咏美分享了自己挑选作品的标准、对表演的理解，以及从业多年来的心态变化。',
    content: [
      '在一场为期两小时的深度专访中，深田咏美少有地谈及了自己对表演的理解。她说，比起剧本的体量，她更在意角色有没有「真正活过」。',
      '「一个角色如果只有功能，没有生活，那观众是能感觉到的。」她提到，自己在读剧本时习惯先为角色写一份「背景小传」，哪怕这些内容最终不会出现在成片里。',
      '谈到从业以来的变化，她表示自己不再那么在意结果，而是更享受拍摄现场的过程。「以前会紧张别人怎么看，现在更想知道自己有没有做到位。」',
      '采访最后，她透露接下来会有两个不同类型的项目在筹备中，其中一个与纪录片相关，具体信息将在合适的时候公布。',
    ],
  },
  {
    id: 'n005',
    title: '《银幕之后》上线，揭秘剧组真实的一天',
    category: '作品发布',
    date: '2026-08-30',
    thumb:
      'https://readdy.ai/api/search-image?query=backstage%20film%20studio%20documentary%20scene%20with%20warm%20spotlights%20and%20camera%20equipment%2C%20muted%20grey%20tones%20with%20deep%20red%20accent%2C%20cinematic%20editorial%20photography%2C%20high%20detail&width=800&height=600&seq=enews-05&orientation=landscape',
    summary:
      '纪录片《银幕之后》正式上线，镜头走进拍摄现场的后台，记录一部电影从筹备到杀青的完整过程。',
    content: [
      '纪录片《银幕之后》本周正式上线。影片走进拍摄现场的后台，用镜头记录一部电影从筹备、拍摄到杀青的完整过程。',
      '作为主要讲述者之一，深田咏美在片中分享了剧组各个岗位之间的协作，以及一个镜头背后往往需要多少次尝试。「观众看到的是两小时，看不到的是两百个小时。」',
      '纪录片没有回避行业的辛苦与不确定，也因此格外真实。有观众评价说，看完之后「再看电影，会多一分别的敬意」。',
    ],
    relatedWorkId: 'w004',
  },
  {
    id: 'n006',
    title: '《静默之声》重映在即，经典片段引发新一轮讨论',
    category: '最新动态',
    date: '2026-08-22',
    thumb:
      'https://readdy.ai/api/search-image?query=moody%20cinematic%20piano%20scene%20in%20a%20dim%20old%20bookstore%20with%20soft%20dusty%20light%2C%20muted%20grey%20and%20deep%20red%20tones%2C%20editorial%20film%20still%2C%20high%20detail&width=800&height=600&seq=enews-06&orientation=landscape',
    summary:
      '文艺电影《静默之声》宣布将在多个城市进行限定重映，深田咏美那段无声的钢琴戏份被网友称为「教科书级表演」。',
    content: [
      '文艺电影《静默之声》宣布将在多个城市进行限定重映。影片讲述一位曾经的天才钢琴少女在意外后失去登台勇气，多年后在旧书店重新听见改变她一生的旋律。',
      '其中一段长达数分钟的无声钢琴戏份，被网友称为「教科书级表演」。深田咏美在采访中坦言，这场戏没有台词，只能依靠呼吸与手指的细微动作去传递情绪。',
      '此次重映将附带一段主创映后谈，导演小林律与深田咏美将回顾影片的创作缘起。重映场次将从下月起陆续开放购票。',
    ],
    relatedWorkId: 'w003',
  },
  {
    id: 'n007',
    title: '粉丝见面会圆满举行，深田咏美现场首唱主题曲',
    category: '活动报道',
    date: '2026-08-10',
    thumb:
      'https://readdy.ai/api/search-image?query=warm%20indoor%20fan%20event%20stage%20with%20soft%20spotlights%20and%20a%20muted%20grey%20backdrop%2C%20deep%20red%20stage%20accent%2C%20editorial%20photography%2C%20cinematic%20mood%2C%20high%20detail&width=800&height=600&seq=enews-07&orientation=landscape',
    summary:
      '深田咏美年度粉丝见面会在东京举行，现场首度公开演唱新片主题曲，与到场粉丝分享拍摄趣事。',
    content: [
      '深田咏美年度粉丝见面会日前在东京举行，门票在开售当天即告售罄。活动以「光影之间」为主题，回顾了她近年的代表作品。',
      '现场，深田咏美首度公开演唱了新片《夜色微光》的主题曲，虽然自谦「不是专业歌手」，但仍获得全场大合唱的回应。',
      '在互动环节，她回答了粉丝提前提交的问题，包括最难忘的拍摄经历、合作过的演员印象等。活动尾声，她向粉丝鞠躬致谢，并预告了接下来的作品计划。',
    ],
  },
  {
    id: 'n008',
    title: '《城中之夏》开播，职场群像获年轻观众共鸣',
    category: '作品发布',
    date: '2026-07-18',
    thumb:
      'https://readdy.ai/api/search-image?query=city%20rooftop%20at%20golden%20hour%20with%20a%20small%20creative%20team%2C%20muted%20grey%20warm%20tones%20with%20deep%20red%20accent%2C%20cinematic%20editorial%20photography%2C%20high%20detail&width=800&height=600&seq=enews-08&orientation=landscape',
    summary:
      '都市职场剧《城中之夏》正式开播，讲述一家濒临解散的设计工作室用一个夏天完成最后项目的故事。',
    content: [
      '都市职场剧《城中之夏》本周正式开播。剧集讲述了在一家濒临解散的小型设计工作室里，一群年轻人决定用一个夏天赌上全部去完成最后一个项目。',
      '深田咏美在剧中饰演团队的核心成员，既有职场上的果断，也有面对伙伴时的柔软。她表示，这个角色最吸引她的是「她从不觉得自己是主角」。',
      '开播首周，剧集在年轻观众中引发广泛共鸣，不少人在社交平台分享自己被某段台词戳中的瞬间。',
    ],
    relatedWorkId: 'w009',
  },
  {
    id: 'n009',
    title: '深田咏美担任某公益影像计划发起人',
    category: '最新动态',
    date: '2026-06-29',
    thumb:
      'https://readdy.ai/api/search-image?query=soft%20documentary%20scene%20of%20a%20community%20photography%20project%20in%20warm%20natural%20light%2C%20muted%20grey%20tones%20with%20deep%20red%20accent%2C%20editorial%20photography%2C%20high%20detail&width=800&height=600&seq=enews-09&orientation=landscape',
    summary:
      '深田咏美宣布以发起人身份参与一项公益影像计划，用镜头记录普通人的故事，鼓励更多人拿起相机。',
    content: [
      '深田咏美宣布以发起人身份参与一项公益影像计划，计划面向普通人征集生活影像，用镜头记录那些容易被忽略的日常瞬间。',
      '「每个人都是自己故事的主角。」她在项目介绍中说，希望这项计划能让更多人意识到，平凡的生活同样值得被认真记录。',
      '据悉，入选作品将在年底以线下展览的形式呈现，部分创作者还将获得与专业团队合作拍摄的机会。',
    ],
  },
  {
    id: 'n010',
    title: '《花火之约》登陆多个海外平台，评分稳步上升',
    category: '最新动态',
    date: '2026-06-05',
    thumb:
      'https://readdy.ai/api/search-image?query=summer%20night%20fireworks%20over%20a%20small%20town%20with%20warm%20lights%2C%20muted%20grey%20with%20deep%20red%20sparks%2C%20cinematic%20editorial%20photography%2C%20high%20detail&width=800&height=600&seq=enews-10&orientation=landscape',
    summary:
      '青春剧《花火之约》陆续登陆多个海外流媒体平台，凭借温暖治愈的叙事收获海外观众好评。',
    content: [
      '青春剧《花火之约》近日陆续登陆多个海外流媒体平台，凭借温暖治愈的叙事风格收获了不少海外观众的喜爱，评分稳步上升。',
      '剧集以每年夏天的花火大会为线索，讲述几位童年好友为了兑现被遗忘的承诺陆续回到故乡的故事。深田咏美在剧中饰演的是一位选择留下的人。',
      '有海外观众在评论区写道：「虽然听不太懂当地的夏天，但那种想念一个地方的感觉是共通的。」',
    ],
    relatedWorkId: 'w006',
  },
  {
    id: 'n011',
    title: '幕后专访：为了《寒灯独影》，她把自己「关了」一个月',
    category: '媒体采访',
    date: '2026-05-20',
    thumb:
      'https://readdy.ai/api/search-image?query=dim%20period%20room%20with%20a%20single%20lantern%20and%20vintage%20camera%20props%2C%20deep%20red%20and%20charcoal%20tones%2C%20moody%20editorial%20photography%2C%20film%20grain%2C%20high%20detail&width=800&height=600&seq=enews-11&orientation=landscape',
    summary:
      '在《寒灯独影》的幕后专访中，深田咏美回忆了为角色做准备的独特方式，以及拍摄中最难的一场戏。',
    content: [
      '在电影《寒灯独影》的幕后专访中，深田咏美回忆了为角色做准备的方式。为了贴近那位独自经营旧照相馆的女子，她提前一个月减少了社交，把自己「关」进了角色的状态里。',
      '「她是一个习惯独处的人，如果我还是按平时的节奏生活，就抓不住她。」她说，那段时间她甚至调整了自己的作息，只为了找到角色身上的那种安静。',
      '谈到最难的戏份，她提到了一场没有任何台词的长镜头，需要靠一个眼神的变化去交代情绪的转折，前后拍了十几条才达到导演的要求。',
    ],
    relatedWorkId: 'w007',
  },
  {
    id: 'n012',
    title: '《追光的人》获纪录片单元推荐，深田咏美谈幕后坚持',
    category: '活动报道',
    date: '2026-05-02',
    thumb:
      'https://readdy.ai/api/search-image?query=lone%20silhouette%20walking%20toward%20warm%20light%20in%20a%20grey%20foggy%20landscape%2C%20muted%20editorial%20photography%2C%20deep%20red%20highlight%2C%20cinematic%20mood%2C%20high%20detail&width=800&height=600&seq=enews-12&orientation=landscape',
    summary:
      '纪录片《追光的人》获得某影展纪录片单元推荐，深田咏美在映后谈中分享了拍摄期间的坚持与收获。',
    content: [
      '纪录片《追光的人》获得某影展纪录片单元推荐。影片跟随深田咏美走过她演艺生涯中几个重要阶段，记录一位表演者如何在聚光灯之外持续打磨自己。',
      '在映后谈中，深田咏美坦言这次拍摄让她重新审视了自己的职业。「镜头一直跟着你，你会不自觉地想，我到底在坚持什么。」',
      '她表示，纪录片的拍摄方式与剧情片完全不同，需要更坦诚地面对自己。这次经历也让她对幕后创作者多了一份敬意。',
    ],
    relatedWorkId: 'w008',
  },
];